/**
 * Vite-safe re-export of react-quill-new (handles ESM default interop).
 */
import QuillEditor from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const ReactQuill = QuillEditor?.default ?? QuillEditor;

export default ReactQuill;
